import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

export default function MobileHome({ user }) {
  const navigate = useNavigate();
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    supabase.from('restaurants').select('name, emoji, color').order('name')
      .then(({ data }) => { setRestaurants(data || []); setLoading(false); });
  }, []);

  const filtered = restaurants.filter(r =>
    r.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', fontFamily: 'Inter, system-ui, sans-serif' }}>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #3a7d00, #1f4500)',
        padding: '3rem 1.25rem 1.5rem',
        position: 'sticky', top: 0, zIndex: 10,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <div style={{ color: '#fff', fontWeight: 800, fontSize: '1.6rem', letterSpacing: '-0.02em' }}>MacRO 🍔</div>
          {user ? (
            <button onClick={() => supabase.auth.signOut()} style={{
              background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff',
              borderRadius: '20px', padding: '0.4rem 0.9rem', fontSize: '0.8rem', fontWeight: 600,
            }}>Sign Out</button>
          ) : (
            <button onClick={() => navigate('/auth')} style={{
              background: '#fff', border: 'none', color: '#3a7d00',
              borderRadius: '20px', padding: '0.4rem 0.9rem', fontSize: '0.8rem', fontWeight: 700,
            }}>Login</button>
          )}
        </div>
        {/* Search */}
        <div style={{ position: 'relative' }}>
          <span style={{ position: 'absolute', left: '0.85rem', top: '50%', transform: 'translateY(-50%)', fontSize: '1rem' }}>🔍</span>
          <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search restaurants..."
            style={{
              width: '100%', padding: '0.75rem 1rem 0.75rem 2.5rem',
              borderRadius: '12px', border: 'none', fontSize: '0.95rem',
              background: 'rgba(255,255,255,0.95)', color: '#111',
              boxSizing: 'border-box', outline: 'none',
            }}
          />
        </div>
      </div>

      {/* Restaurant list */}
      <div style={{ padding: '1rem' }}>
        <div style={{ fontSize: '0.8rem', color: '#888', marginBottom: '0.75rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          {loading ? 'Loading...' : `${filtered.length} Restaurants`}
        </div>
        {filtered.map(r => (
          <div
            key={r.name}
            onClick={() => navigate(`/restaurant/${encodeURIComponent(r.name)}`)}
            style={{
              background: '#fff', borderRadius: '14px', padding: '1rem 1.1rem',
              marginBottom: '0.6rem', display: 'flex', alignItems: 'center', gap: '1rem',
              boxShadow: '0 1px 3px rgba(0,0,0,0.07)', cursor: 'pointer',
              borderLeft: `4px solid ${r.color}`,
              WebkitTapHighlightColor: 'transparent',
            }}
          >
            <span style={{ fontSize: '2rem', lineHeight: 1, minWidth: '2.5rem', textAlign: 'center' }}>{r.emoji}</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: '1rem', color: '#111' }}>{r.name}</div>
              <div style={{ color: '#888', fontSize: '0.8rem', marginTop: '0.15rem' }}>Tap to view macros →</div>
            </div>
            <span style={{ color: '#ccc', fontSize: '1.2rem' }}>›</span>
          </div>
        ))}
      </div>
    </div>
  );
}
